import * as React from 'react';

function SvgLeftArrow(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 7.61 11.967" {...props}>
      <path
        data-name="Path 2855"
        d="M.331 6.844l4.9 4.794a1.18 1.18 0 001.635 0l.407-.4a1.12 1.12 0 00.016-1.579l-.016-.016-3.74-3.661 3.74-3.661A1.12 1.12 0 007.289.742L7.273.727l-.407-.4a1.18 1.18 0 00-1.635 0L2.016 3.469.327 5.12A1.09 1.09 0 000 5.981a1.113 1.113 0 00.331.863z"
        fill="#0271c2"
      />
    </svg>
  );
}

export default SvgLeftArrow;
